import Layout from '@layouts/Layout';
import PrivacyPolicy from '@screens/Legal/PrivacyPolicy';

import React, { memo } from 'react';

const title = 'Privacy policy';
const description = 'Protecting your privacy is our utmost priority here at Traqq. Read Traqq’s full privacy policy on this page and get to know all the terms and conditions.';

const PrivacyPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <PrivacyPolicy />
    </Layout>
);

export default memo(PrivacyPage);
